import { render, staticRenderFns } from "./Reviewdatails.vue?vue&type=template&id=fb19409a&scoped=true"
import script from "./Reviewdatails.vue?vue&type=script&lang=js"
export * from "./Reviewdatails.vue?vue&type=script&lang=js"
import style0 from "./Reviewdatails.vue?vue&type=style&index=0&id=fb19409a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb19409a",
  null
  
)

export default component.exports